import gsap from 'gsap'

export class MouseFollow {
  constructor({ els, container}) {
    this.els = els
    this.container = container
    this.xForce = 0
    this.yForce = 0
    this.easing = 0.08
    this.speed = 0.01
    this.requestAnimationFrameId = null

    this._animate = this._animate.bind(this)
    this._lerp = this._lerp.bind(this)

    this.init()
  }

  init() {
    this.container.addEventListener('mousemove', (e) => {
      const { movementX, movementY } = e

      this.xForce += movementX * this.speed
      this.yForce += movementY * this.speed

      if (this.requestAnimationFrameId === null) {
        this.requestAnimationFrameId = requestAnimationFrame(this._animate)
      }
    })

    this.container.addEventListener('mouseleave', () => {
      this.els.forEach(({el}) => {
        gsap.to(el, {
          x: 0,
          y: 0,
          duration: 0.8,
          ease: 'power3.inOut'
        })
      })

      this.xForce = 0
      this.yForce = 0

      if (this.requestAnimationFrameId !== null) {
        cancelAnimationFrame(this.requestAnimationFrameId)
        this.requestAnimationFrameId = null
      }
    })
  }

  _lerp(start, target, amount) {
    return start * (1 - amount) + target * amount
  }

  _animate() {
    this.xForce = this._lerp(this.xForce, 0, this.easing)
    this.yForce = this._lerp(this.yForce, 0, this.easing)

    this.els.forEach(({el, forceModifier}) => {
      gsap.set(el, {
        x: `+=${this.xForce * forceModifier}`,
        y: `+=${this.yForce * forceModifier}`
      })
    })

    if (Math.abs(this.xForce) < 0.01) this.xForce = 0
    if (Math.abs(this.yForce) < 0.01) this.yForce = 0

    if (this.xForce !== 0 || this.yForce !== 0) {
      this.requestAnimationFrameId = requestAnimationFrame(this._animate)
    } else {
      cancelAnimationFrame(this.requestAnimationFrameId)
      this.requestAnimationFrameId = null
    }
  }
}

export default function createMouseFollow(config) {
  return new MouseFollow(config)
}
